import React, { Component } from 'react';
import { DragSource } from 'react-dnd';
import PMWindow from '../PMWindow';
import '../PMWindowedApp.css';
import { PMDNDTypes } from '../constants';

class PMDesktopWindow extends Component {
	state = {
		minimized: false,
		visible: true,
	}

	funcMinimize = () => {
		//console.log("[PMDesktopWindow] funcMinimize");
		const { index } = this.props;
		const { minimized } = this.state;
		this.props.funcResize(index, minimized);
		this.setState({
			minimized: !this.state.minimized
		});
	}

	funcClose = () => {
		//console.log("[PMDesktopWindow] closing");
		const { index } = this.props;
		this.setState({
			visible: !this.state.visible
		});
		this.props.funcRemoveWindow(index);
	}

	funcMoveZ = () => {
		this.props.funcMoveZ(this.props.index);
	}

	render() {
		const { connectDragPreview, window, data, index, color } = this.props;
		const { minimized } = this.state

		return connectDragPreview(
			<div>
				<PMWindow
					color={color}
					children={this.props.children}
					window={window}
					data={data}
					minimized={this.state.minimized}
					index={index}
					key={index}
					funcMinimize={this.funcMinimize}
					funcClose={this.funcClose}
					funcMoveZ={this.funcMoveZ}
					funcAction={this.funcAction}
					connectDragPreview={connectDragPreview}
				/>
			</div>
		)
	}
}


const dragSource = {
	beginDrag: function (props, monitor, component) {
		//console.log("[PMDesktopWindow] beginDrag");
		return props
	},
	isDragging: function (props, monitor, component) {
		//console.log("[PMDesktopWindow] dragging");
	},
	endDrag: function (props, monitor, component) {
		if (!monitor.didDrop()) {
			return;
		} else {
			//console.log("[PMDesktopWindow] endDrag");
			//const item = monitor.getItem();
			//console.log(item);
			//const dropResult = monitor.getDropResult();
			//console.log(dropResult);

			component.setState({
				yTop: component.props.yTop + 50,
				xLeft: component.props.xLeft + 50
			})
		}
	}
}

function dragCollect(connect, monitor, component) {
	return {
		connectDragSource: connect.dragSource(),
		connectDragPreview: connect.dragPreview(),
		isDragging: monitor.isDragging(),
	}
}

PMDesktopWindow = DragSource(PMDNDTypes.WINDOW, dragSource, dragCollect)(PMDesktopWindow);
export default PMDesktopWindow;


// WEBPACK FOOTER //
// ./src/components/projectmanager/desktop/PMDesktopWindow.js